import BenefitsTile from ".";

export default function BenefitsTileExamples() {
  return <BenefitsTile benefitCount={10} isLoading={false} isError={true} />;
}
